import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import token from '../../utils/token';
import history from '../../utils/history';
import { signInFlow } from '../../store/actions/auth';
import { SIGNIN_PATH } from '../../constants/pathRedirect';

function SignInFlowContainer(props) {
  const { signInFlow } = props;

  useEffect(() => {
    const hasToken = !!token.getToken();

    if (hasToken) {
      signInFlow();
    } else {
      history.push(SIGNIN_PATH);
    }
  }, [signInFlow]);

  return <div />;
}

const mapDispatchToProps = (dispatch) => ({
  signInFlow: () => dispatch(signInFlow()),
});

export default connect(null, mapDispatchToProps)(SignInFlowContainer);
